export const ContextViolationTypes = {
  MIXED_CONTEXT: 'MIXED_CONTEXT',
  AGGREGATION_CONTEXT: 'AGGREGATION_CONTEXT'
};
export const isMixedContextViolation = violation => violation.type === ContextViolationTypes.MIXED_CONTEXT;
export const isAggregationContextViolation = violation => violation.type === ContextViolationTypes.AGGREGATION_CONTEXT;
export const isContextViolation = violation => isMixedContextViolation(violation) || isAggregationContextViolation(violation);